/** TypeScript interfaces for the TCC viewer + coordination findings worklist. */

export interface TccCurveSet {
  device_id: number
  device_name: string | null
  speed: string | null
  rating_amps: number | null
  minimum_melt: number[][] | null
  total_clear: number[][] | null
}
export interface TccPairCurves {
  upstream: TccCurveSet
  downstream: TccCurveSet
  fault_current_a: number | null
  coordination_status: string
  mm_upstream_s: number | null
  tc_downstream_s: number | null
  melt_ratio: number | null
  indicative_only: boolean
  notes: string | null
}
export type Disposition = 'open' | 'acknowledged' | 'field_corrected'
export interface CoordinationFinding {
  id: number
  feeder_id: number | null
  upstream_device_id: number
  downstream_device_id: number
  coordination_status: string
  fault_current_ka: number | null
  margin_detail: Record<string, unknown> | null
  evaluated_at: string | null
  disposition: Disposition
  disposition_by: string | null
  disposition_at: string | null
  disposition_notes: string | null
}
export interface CoordinationFindingList {
  feeder_id: number
  total: number
  open_count: number
  acknowledged_count: number
  field_corrected_count: number
  findings: CoordinationFinding[]
}
export const DISPOSITION_LABELS: Record<Disposition, string> = {
  open: 'Open',
  acknowledged: 'Acknowledged',
  field_corrected: 'Field-corrected',
}
